import styled from 'styled-components'

export default styled.div`
	width: max-content;
	padding: 2px 6px 2px 0;
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	color: #777;
	gap: 5px;
	.icon {
		width: 16px;
		height: 16px;
		svg {
			width: 16px;
			height: 16px;
		}
	}
`
